import React from "react";

import type { ProcessedBetEntry } from "@/hooks/firestore/betting/useEntries";
import type { CashOutProps } from "../../types/entries";

import { Collapse } from "@picklebet/ui";
import { EntryHeader } from "../EntryHeader";
import { MysteryMultiHeader } from "@/features/sem-generator/components/MysteryMultiHeader";
import { BetEntrySelectionList } from "./BetEntrySelectionList";
import { BetEntrySummary } from "./BetEntrySummary";
import { Promotion } from "./Promotion";
import { BetEntryCashOut } from "./BetEntryCashOut";
import { isCashOutSuspended, mysteryMultiOf } from "../../util/entry-helpers";

import * as styles from "./BetEntry.module.scss";

interface BetEntryProps {
  entry: ProcessedBetEntry;
  cashOut?: CashOutProps;
  isPreview: boolean;
  isCompact: boolean;
}

const BetEntry = ({ entry, cashOut, isPreview, isCompact }: BetEntryProps) => {
  const cashOutSuspended = isCashOutSuspended(entry, cashOut?.amount);
  const mysteryMulti = mysteryMultiOf(
    entry.data.multiBuilderType,
    entry.data.mysteryMultiLevel,
  );

  return (
    <div className={styles.betEntryContainer}>
      {mysteryMulti && <MysteryMultiHeader level={mysteryMulti.level} />}

      <EntryHeader entry={entry} isPreview={isPreview} />

      <BetEntrySelectionList entry={entry} isPreview={isPreview} />

      <Promotion entry={entry} isPreview={isPreview} />

      <BetEntrySummary
        entry={entry}
        isCompact={isCompact}
        isPreview={isPreview}
      />

      <Collapse isOpen={(!!cashOut || cashOutSuspended) && !entry.shareId}>
        <BetEntryCashOut
          entry={entry}
          cashOut={cashOut}
          isCashOutSuspended={cashOutSuspended}
        />
      </Collapse>
    </div>
  );
};

export { BetEntry };
